/**
 * Generated by `pnpm generate:sdk-types` — DO NOT EDIT BY HAND.
 *
 * `PluginPermission` union + `VALID_PLUGIN_PERMISSIONS` const,
 * sourced from `@fias/db-types`. Generated (not re-exported) so the
 * SDK has no runtime dependency on db-types — the SDK ships in
 * plugin iframes and must stay bundle-clean.
 *
 * `tests/architecture/sdk-permissions-match-db-types.test.ts` ensures
 * this file stays in lockstep with the canonical source.
 */

export type PluginPermission =
  | 'assets:read'
  | 'data:search'
  | 'data:store'
  | 'data:workspace'
  | 'entities:audio_generate'
  | 'entities:client_invoke'
  | 'entities:image_edit'
  | 'entities:image_generate'
  | 'entities:invoke'
  | 'entities:web_search'
  | 'navigation:open_arche'
  | 'sandbox:vendored-libraries'
  | 'storage:sandbox'
  | 'store:purchase'
  | 'theme:read'
  | 'user:profile:read'
  | 'vault:documents:read'
  | 'vault:documents:write'
  | 'vault:user-documents:read';

export const VALID_PLUGIN_PERMISSIONS: readonly PluginPermission[] = [
  'assets:read',
  'data:search',
  'data:store',
  'data:workspace',
  'entities:audio_generate',
  'entities:client_invoke',
  'entities:image_edit',
  'entities:image_generate',
  'entities:invoke',
  'entities:web_search',
  'navigation:open_arche',
  'sandbox:vendored-libraries',
  'storage:sandbox',
  'store:purchase',
  'theme:read',
  'user:profile:read',
  'vault:documents:read',
  'vault:documents:write',
  'vault:user-documents:read',
] as const;

export function isValidPluginPermission(perm: string): perm is PluginPermission {
  return (VALID_PLUGIN_PERMISSIONS as readonly string[]).includes(perm);
}

/**
 * USER-FACING one-line description per permission — what consent /
 * store surfaces show a non-technical user. Sourced from db-types'
 * PLUGIN_PERMISSION_DESCRIPTIONS.
 */
export const PLUGIN_PERMISSION_DESCRIPTIONS: Readonly<Record<PluginPermission, string>> = {
  'assets:read': "Show images from this app's published asset library.",
  'data:search': "Search this app's own data semantically — costs credits per search.",
  'data:store': "Save structured data in this app's own private database.",
  'data:workspace': 'Create team workspaces and manage their members.',
  'entities:audio_generate': 'Generate audio with platform AI — costs credits.',
  'entities:client_invoke':
    'Use free on-device tools (grammar check, translation) in your browser.',
  'entities:image_edit': 'Edit images with platform AI — costs credits.',
  'entities:image_generate': 'Generate images with platform AI — costs credits.',
  'entities:invoke': 'Use platform AI (text) on your behalf — costs credits.',
  'entities:web_search': 'Search the live web on your behalf — costs credits.',
  'navigation:open_arche': 'Open other arches for you (navigation only).',
  'sandbox:vendored-libraries':
    'Load platform-hosted libraries (like the PDF renderer) from the trusted CDN.',
  'storage:sandbox': "Save files in this app's own private storage.",
  'store:purchase': 'Offer in-app purchases (you approve each purchase).',
  'theme:read': 'Match your platform theme.',
  'user:profile:read': 'See your display name and avatar.',
  'vault:documents:read': 'Read documents this app itself created in your Vault.',
  'vault:documents:write': 'Create and manage its own documents in your Vault.',
  'vault:user-documents:read':
    'Read documents YOU choose to share with it from your Vault — you pick each document, and you can remove access any time in Vault → App Access.',
};
